var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.963 6.901 11.1 10.803 9.036 8.72l-1.273 1.286 3.337 3.369 5.136-5.187L14.963 6.9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.078 17.542 6.6 21v-3.458H4.8c-.994 0-1.8-.814-1.8-1.818V4.819C3 3.814 3.806 3 4.8 3h14.4c.994 0 1.8.814 1.8 1.818v10.907a1.809 1.809 0 0 1-1.8 1.817h-7.122ZM8.4 17.72l3.162-1.995H19.2V4.818H4.8v10.907h3.6v1.995Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCheck);
export default __webpack_public_path__ + "static/media/message-check.0f5c190a.svg";
export { ForwardRef as ReactComponent };